"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.structuredDocs = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const MethodManager_1 = require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods_customer");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
const customerTemplates_1 = require("./customerTemplates");
require("./structuredDocs.tmpl.less");
const $ = require("jquery");
const m = require("../SynView");
let r_defStructureTemplate = require("./templates/tile.structure.tmpl.htm");
let r_defElementTemplate = require("./templates/tile.element.tmpl.htm");
let r_devNavTypeTemplate = require("./templates/tile.navigationType.tmpl.htm");
class BreadCrumbItem {
    constructor(url, name) {
        this.url = url;
        this.name = name;
    }
}
class SearchField {
}
class structuredDocs extends m.SynView {
    //#region CONTRUCTORS
    constructor() {
        super();
        this.m_hasMenu = false;
        this.m_externalChangeEventRegistered = false;
    }
    //#endregion Controls
    //#endregion MEMBER VARIABLES
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-th-list";
        this.m_hasNextLevel = false;
    }
    setURL() {
        $.address.autoUpdate(false);
        if (!this.IsActiveView)
            return;
        $.address.update();
        $.address.autoUpdate(true);
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        this.m_type = typeof $.address.parameter("type") !== "undefined" ? decodeURIComponent($.address.parameter("type")) : undefined;
        this.m_path = typeof $.address.parameter("path") !== "undefined" ? decodeURIComponent($.address.parameter("path")) : "";
        this.m_search = typeof $.address.parameter("search") !== "undefined" ? decodeURIComponent($.address.parameter("search")) : undefined;
        this.m_searchField = $.address.parameter("searchField") || undefined;
        this.m_searchDisplayText = typeof $.address.parameter("displayText") !== "undefined" ? decodeURIComponent($.address.parameter("displayText")) : undefined;
    }
    renderContents() {
        let that = this;
        that.m_$breadCrumbNavigation = that.m_$container.find("#structuredDocsBreadCrumbNavigation").html("");
        that.m_$searchRow = that.m_$container.find("#structuredDocsSearchRow").html("");
        that.m_$tileHolder = that.m_$container.find("#structuredDocsTileHolder").html("");
        that.renderTiles();
        that.renderBreadCrumbNavigation();
        if (!that.m_externalChangeEventRegistered) {
            that.m_externalChangeEventRegistered = true;
            $.address.externalChange((evt) => {
                if (evt.value === "/structuredDocs" || evt.value.indexOf("/structuredDocs?") === 0) {
                    that.getParametersFromUrl();
                    that.renderContents();
                }
            });
        }
    }
    forceRefresh(modificationInfo) { }
    //#endregion Inherited from SynView
    //#region Helpers
    getTileTemplate(navigationType, parentPath, structureElement) {
        let level = Utilities_1.synUtil.splitWithoutEmptyEntries((parentPath || ""), "|").length;
        let templType = structureElement ? "structure" : "element";
        // Try with level-specific template
        let output = customerTemplates_1.customerTemplates["tile." + navigationType + "." + templType + "." + (level) + ".tmpl.htm"];
        if (output)
            return output;
        // Next, fallback without level specificity
        output = customerTemplates_1.customerTemplates["tile." + navigationType + "." + templType + ".tmpl.htm"];
        if (output)
            return output;
        output = structureElement ? r_defStructureTemplate : r_defElementTemplate;
        return output;
    }
    templateOptions(obj) {
        return {
            synUtil: Utilities_1.synUtil,
            type: this.m_type,
            path: this.m_path,
            instance: obj.instance || undefined,
            id: obj.id || undefined,
            name: obj.name || undefined,
            childItems: obj.childItems
        };
    }
    renderNextLevelTiles() {
        let that = this;
        that.m_hasNextLevel = false;
        that.waitAnim(true);
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + that.m_type + "/nextLevel/",
            method: "POST",
            requestData: { "parentPath": that.m_path },
            done: (nextLevel) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                for (let item of nextLevel.structureObjects) {
                    if (item.instance) {
                        item.instance = yield Instance_1.Instance.fromJSON(item.instance);
                    }
                }
                nextLevel.elementObjects = yield Instance_1.Instance.fromJSONArray(nextLevel.elementObjects);
                that.m_$tileHolder.html("");
                let structureTemplate = that.getTileTemplate(that.m_type, that.m_path, true);
                let elementTemplate = that.getTileTemplate(that.m_type, that.m_path, false);
                that.m_hasNextLevel = nextLevel.structureObjects.length > 0;
                nextLevel.structureObjects.sort((s1, s2) => {
                    if (s1.instance)
                        return s1.instance.name.value.localeCompare(s2.instance.name.value);
                    else
                        return s1.name.localeCompare(s2.name);
                });
                nextLevel.elementObjects.sort((e1, e2) => e1.name.value.localeCompare(e2.name.value));
                $.each(nextLevel.structureObjects, (idx, structureObj) => {
                    let tmpl = kendo.template(structureTemplate);
                    that.m_$tileHolder.append(tmpl(that.templateOptions(structureObj)));
                });
                $.each(nextLevel.elementObjects, (idx, elementObj) => {
                    let tmpl = kendo.template(elementTemplate);
                    that.m_$tileHolder.append(tmpl(that.templateOptions({ instance: elementObj, childElements: 0 })));
                });
                that.registerViewLinks();
                that.renderSearchRow();
            }),
            cleanUp: () => that.waitAnim(false)
        });
    }
    renderSearchResults() {
        let that = this;
        that.waitAnim(true);
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + that.m_type + "/search/",
            method: "POST",
            requestData: {
                "parentPath": that.m_path,
                "searchField": that.m_searchField,
                "searchText": that.m_search
            },
            done: (searchResultsJSON) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let searchResults = yield Instance_1.Instance.fromJSONArray(searchResultsJSON);
                that.m_$tileHolder.html("");
                let template = that.getTileTemplate(that.m_type, that.m_path, false);
                $.each(searchResults, (idx, elementObj) => {
                    let tmpl = kendo.template(template);
                    that.m_$tileHolder.append(tmpl(that.templateOptions({ instance: elementObj, childElements: 0 })));
                });
                if (searchResults.length === 0)
                    that.m_$tileHolder.append("<div class='tileCol col-md-12 col-sm-12'><div class='tile noResultsTile'>"
                        + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("searchnoresults"))
                        + "</div></div>");
                that.renderSearchRow();
                that.registerViewLinks();
            }),
            cleanUp: () => that.waitAnim(false)
        });
    }
    renderRootNodes() {
        let that = this;
        that.waitAnim(true);
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + that.m_type + "/rootNodes/",
            done: (rootNodes) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                for (let item of rootNodes) {
                    item.instance = yield Instance_1.Instance.fromJSON(item.instance);
                }
                rootNodes.sort((r1, r2) => r1.instance.name.value.localeCompare(r2.instance.name.value));
                let template = that.getTileTemplate(that.m_type, "", true);
                that.m_$tileHolder.html("");
                that.m_hasNextLevel = rootNodes.length > 0;
                $.each(rootNodes, (idx, rootNode) => {
                    let tmpl = kendo.template(template);
                    that.m_$tileHolder.append(tmpl(that.templateOptions(rootNode)));
                });
                that.renderSearchRow();
            }),
            cleanUp: () => {
                that.waitAnim(false);
            }
        });
    }
    renderNavigationTypes() {
        let that = this;
        that.waitAnim(true);
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + "navigationTypes/",
            done: (navTypes) => {
                if (navTypes.length === 1) {
                    $.address.parameter("type", encodeURIComponent(navTypes[0].navType), false);
                    this.getParametersFromUrl();
                    this.renderContents();
                }
                else {
                    that.m_$tileHolder.html("");
                    $.each(navTypes, (idx, type) => {
                        type["synUtil"] = Utilities_1.synUtil;
                        let tmpl = kendo.template(r_devNavTypeTemplate);
                        that.m_$tileHolder.append(tmpl(type));
                    });
                }
            },
            cleanUp: () => {
                that.waitAnim(false);
            }
        });
    }
    renderTiles() {
        let that = this;
        if (that.m_type) {
            if (that.m_search)
                that.renderSearchResults();
            else if (that.m_path)
                that.renderNextLevelTiles();
            else
                that.renderRootNodes();
        }
        else
            that.renderNavigationTypes();
    }
    renderBreadCrumbNavigation() {
        let that = this;
        if (!that.m_type) {
            that.m_$breadCrumbNavigation.html("&nbsp;");
            return;
        }
        that.getBreadCrumbNavigation((items) => {
            that.m_$breadCrumbNavigation.html("&nbsp;");
            $.each(items, (idx, item) => {
                let $span = $("<span></span>").addClass("breadCrumb").appendTo(that.m_$breadCrumbNavigation);
                let $link = $("<a></a>").attr("href", item.url).text(item.name).appendTo($span);
                if (idx === items.length - 1)
                    $link.attr("disabled", "disabled");
            });
        });
    }
    getBreadCrumbNavigation(callback) {
        let that = this;
        let requestData = {};
        if (that.m_path)
            requestData.parentPath = that.m_path;
        if (that.m_type)
            requestData.navigationType = that.m_type;
        if (that.m_search) {
            requestData.searchText = that.m_search;
            requestData.searchField = that.m_searchField;
            if (that.m_searchDisplayText)
                requestData.searchDisplayText = that.m_searchDisplayText;
        }
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + "breadCrumbNavigation/",
            method: "POST",
            requestData,
            done: callback
        });
    }
    static encodeHtmlAttribute(value) {
        if (!value)
            return "";
        return $("<div/>").html(value).text();
    }
    renderSearchRow() {
        let that = this;
        if ((!that.m_hasNextLevel || !that.m_type) && !that.m_search) {
            that.m_$searchRow.html("");
            return;
        }
        that.getSearchFields((fields) => {
            that.m_$searchRow.html("");
            $.each(fields, (idx, field) => {
                let $col = $("<div class='tileCol'></div>").appendTo(that.m_$searchRow);
                if (fields.length === 2)
                    $col.addClass("col-md-6 col-sm-6");
                else
                    $col.addClass("col-md-12 col-sm-12");
                if (field.isFtField) {
                    let $dropDownTile = $("<div class='tile dropDownTile'></div>").appendTo($col);
                    let $ddl = $("<select class='dropDown'></select>").css("width", "100%").appendTo($dropDownTile);
                    if (that.m_search && that.m_searchField === field.ftKeyFieldName)
                        $("<option></option>")
                            .attr("value", that.m_search)
                            .text(that.m_searchDisplayText)
                            .appendTo($ddl);
                    $ddl.kendoDropDownList({
                        autoBind: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        dataSource: {
                            transport: {
                                read(attachmentOptions) {
                                    let requestData = {
                                        ftField: field.fieldName
                                    };
                                    if (that.m_path)
                                        requestData.parentPath = that.m_path;
                                    Utilities_1.synUtil.getAJAXData({
                                        url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + that.m_type + "/ftEntries/",
                                        method: "POST",
                                        requestData,
                                        done(data) {
                                            if (!$.grep(data, (obj) => !obj.id).length)
                                                data.splice(0, 0, { id: "", name: "" });
                                            data.sort((d1, d2) => d1.name.localeCompare(d2.name));
                                            attachmentOptions.success(data);
                                        }
                                    });
                                }
                            }
                        },
                        dataBound(e) {
                        },
                        open() {
                            $ddl.data("kendoDropDownList").list.addClass("structuredDocsDropDown");
                        },
                        close() {
                            let ddl = $ddl.data("kendoDropDownList");
                            if (ddl) {
                                let dataItem = ddl.dataItem(ddl.select());
                                if (!dataItem || !dataItem.id)
                                    that.dropDownPlaceholder($ddl, field.fieldTitle);
                            }
                        },
                        change(e) {
                            let ddl = $ddl.data("kendoDropDownList");
                            let dataItem = ddl.dataItem(ddl.select());
                            if (!dataItem || !dataItem.id)
                                that.resetSearch();
                            else {
                                that.dropDownPlaceholder($ddl, undefined);
                                that.search(field.ftKeyFieldName, dataItem.id, dataItem.name);
                            }
                        }
                    });
                    if (that.m_search && that.m_searchField !== field.ftKeyFieldName)
                        $ddl.data("kendoDropDownList").enable(false);
                    if (!that.m_search || that.m_searchField !== field.ftKeyFieldName)
                        that.dropDownPlaceholder($ddl, field.fieldTitle);
                }
                else {
                    let $searchTile = $("<div class='tile searchTile'></div>").appendTo($col);
                    let searchCore = ($searchField) => that.search($searchField.attr("data-fieldname"), $searchField.text());
                    let $searchField = $("<div class='searchField' contenteditable='true'></div>")
                        .attr({
                        "data-placeholder": structuredDocs.encodeHtmlAttribute(field.fieldTitle),
                        "data-fieldname": field.fieldName
                    })
                        .keypress((e) => {
                        if (e.which === 13)
                            searchCore($searchField);
                    })
                        .blur(() => { $searchField.find("br").remove(); })
                        .appendTo($searchTile);
                    let $searchButton = $("<div class='searchButton'><i class='fa fa-search'></i></div>")
                        .on("click", () => { searchCore($searchField); })
                        .appendTo($searchTile);
                    if (that.m_search) {
                        if (that.m_searchField === field.fieldName)
                            $searchField.text(that.m_search);
                        else {
                            $searchField.attr({
                                "disabled": "disabled",
                                "contenteditable": "false",
                            });
                            $searchButton.attr("disabled", "disabled");
                        }
                    }
                }
            });
        });
    }
    registerViewLinks() {
        this.m_$tileHolder.find(".tile.elementTile a.viewLink")
            .on("click", function () {
            MethodManager_1.MethodManager.executeMethod("cefunc.26", [$(this).attr("data-id")], undefined, 0, undefined, undefined);
        });
    }
    dropDownPlaceholder($ddl, placeHolderText) {
        let ddl = $ddl.data("kendoDropDownList");
        if (placeHolderText)
            ddl.span.addClass("placeholder").text(placeHolderText);
        else
            ddl.span.removeClass("placeholder");
    }
    search(fieldName, fieldValue, displayText) {
        if (fieldValue) {
            $.address.autoUpdate(false);
            $.address.parameter("displayText", displayText ? encodeURIComponent(displayText) : undefined, false);
            $.address.parameter("search", encodeURIComponent(fieldValue), false);
            $.address.parameter("searchField", fieldName, false);
            $.address.update();
            $.address.autoUpdate(true);
            this.getParametersFromUrl();
            this.renderContents();
        }
    }
    resetSearch() {
        $.address.autoUpdate(false);
        $.address.parameter("displayText", undefined, false);
        $.address.parameter("search", undefined, false);
        $.address.parameter("searchField", undefined, false);
        $.address.update();
        $.address.autoUpdate(true);
        this.getParametersFromUrl();
        this.renderContents();
    }
    getSearchFields(callback) {
        let that = this;
        let requestData = {};
        if (that.m_path)
            requestData.parentPath = that.m_path;
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("StructuredDocs") + that.m_type + "/searchFields/",
            done: callback
        });
    }
    waitAnim(show) {
        if (show)
            this.m_$tileHolder.html("<div class='tileCol col-md-12 col-sm-12'><div class='tile waitAnimTile'><i class='fa fa-spinner largeIcon'></i></div></div>");
        else
            this.m_$tileHolder.find("div.waitAnimTile").remove();
    }
}
exports.structuredDocs = structuredDocs;
